import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@simplicity/ui";

export interface ErrorFallbackProps {
  error: unknown;
  componentStack: string;
  eventId: string;
  resetError: () => void;
}

export function ErrorFallback({ error, resetError }: ErrorFallbackProps) {
  const rawMessage = error instanceof Error ? error.message : String(error);
  const message = rawMessage.length > 200 ? rawMessage.slice(0, 200) + "…" : rawMessage;

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="text-foreground">Something went wrong</CardTitle>
          <CardDescription>
            An unexpected error occurred. You can try again or reload the page.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <pre className="overflow-auto rounded bg-muted p-3 text-sm text-muted-foreground">
            {message}
          </pre>
        </CardContent>
        <CardFooter className="gap-2">
          <Button variant="outline" onClick={resetError}>
            Try again
          </Button>
          <Button onClick={() => window.location.reload()}>Reload page</Button>
        </CardFooter>
      </Card>
    </div>
  );
}
